import type { SeoResolver } from '../types';

/**
 * SEO for a resolved constituency. New (the layer previously fell back to the
 * generic "<layer> in <area>" title). A constituency is not a dedicated store
 * selection — SEO.tsx passes the active CONSTITUENCY searchResult into
 * `selections.constituency` when it carries assembly_c / parliame_1.
 *
 * Assembly (AC) vs Parliamentary (PC) mirrors the app's own rule
 * (useGisWorker): a feature is a PC when it has parliame_1 but no assembly_c;
 * otherwise it is an AC whose parliame_1 names its parent PC.
 */
export const constituencySeoResolver: SeoResolver = (ctx) => {
  const feat = ctx.selections.constituency;
  if (!feat) return null;

  const { siteName, layerName } = ctx;
  const p = feat.properties as Record<string, unknown>;
  const acName = (p.assembly_c as string) || '';
  const pcName = (p.parliame_1 as string) || '';
  const isPc = !!pcName && !acName;

  if (isPc) {
    const num = p.parliament != null ? ` (PC ${p.parliament})` : '';
    return {
      title: `${pcName}${num} — Parliamentary Constituency | ${layerName} | ${siteName}`,
      description: `${pcName} Parliamentary Constituency${num}, Tamil Nadu. View constituency boundaries and map details on ${siteName}.`,
      breadcrumbLabel: pcName
    };
  }

  const num = p.assembly_1 != null ? ` (AC ${p.assembly_1})` : '';
  const parent = pcName ? `, part of ${pcName} parliamentary constituency` : '';
  const district = p.district_n ? ` in ${p.district_n} district` : '';
  return {
    title: `${acName}${num} — Assembly Constituency | ${layerName} | ${siteName}`,
    description: `${acName} Assembly Constituency${num}${parent}${district}, Tamil Nadu. View constituency boundaries and map details on ${siteName}.`,
    breadcrumbLabel: acName
  };
};
